import axios from 'axios'
import { TOKEN } from 'constants/global.constants'
import { store, persistor } from 'lib/redux'
import { logout as authLogout } from 'ducks/auth/reducer'
import { logout as userLogout } from 'ducks/user/reducer'
import { clearAuthStoragePreservingMfaDevice } from 'services/login/auth-storage'

axios.defaults.baseURL = process.env.REACT_APP_MAIN_API
axios.defaults.headers.common['Content-Type'] = 'application/json'

axios.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem(TOKEN)

    if (token && request.headers) {
      // eslint-disable-next-line
      request.headers['Authorization'] = `Bearer ${token}`
    }

    return request
  },
  (error) => {
    window.location.href = '/login'
    return Promise.reject(error)
  }
)

// Response interceptor to handle 403 errors
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 403) {
      // Check if the request is related to registration/signup routes
      const url = error.config?.url || ''
      const isRegistrationRoute =
        url.includes('/user/one') ||
        url.includes('/register') ||
        url.includes('/signup')

      // Skip logout logic for registration routes
      if (!isRegistrationRoute) {
        // Dispatch logout actions to both reducers
        store.dispatch(authLogout())
        store.dispatch(userLogout())

        // Purge persisted state
        await persistor.purge()

        // Clear auth state while keeping remembered MFA devices.
        clearAuthStoragePreservingMfaDevice()

        // Redirect to login
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export default axios
